export default __webpack_public_path__ + "static/media/facebook-logo.535b429c.svg";